(function () {
  function triggerDownload(blob, fileName) {
    var objectUrl = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(function () {
      URL.revokeObjectURL(objectUrl);
    }, 1000);
  }

  function isSameOrigin(url) {
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function onClick(event) {
    var row = event.currentTarget;
    var href = row.getAttribute('href');
    if (!href) return;

    // Let the browser handle new-tab / new-window clicks and same-origin files.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (isSameOrigin(href)) return;
    if (!window.fetch || !window.URL || !URL.createObjectURL) return;

    event.preventDefault();
    if (row.getAttribute('aria-busy') === 'true') return;

    var fileName = row.getAttribute('data-file-name') || 'document.pdf';
    row.setAttribute('aria-busy', 'true');

    fetch(href, { mode: 'cors', credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) throw new Error('Download failed');
        return response.blob();
      })
      .then(function (blob) {
        triggerDownload(blob, fileName);
      })
      .catch(function () {
        window.location.assign(href);
      })
      .then(function () {
        row.removeAttribute('aria-busy');
      });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-documents-download]').forEach(function (row) {
      if (row.getAttribute('data-documents-ready') === 'true') return;
      row.setAttribute('data-documents-ready', 'true');
      row.addEventListener('click', onClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) init(event.target);
  });
})();
